/** 云上契约-xinxin */
const YUNSHANG_DOMAIN = 'xinxinhw';
/** 神火大陆-shefynmis-越南 */
const VN_DOMAIN = 'shefynmis';

export const getHostName = () => {
  return ((window.location && window.location.hostname) || '').toLowerCase();
};

export const isDomainLaunch = domain => {
  try {
    const host = getHostName();
    if (!host) return false;
    if (host === 'localhost') return false;
    if (/^\d{1,3}(\.\d{1,3}){3}$/.test(host)) return false;
    if (/^\[.*\]$/.test(host)) return false;

    const parts = host.split('.').filter(Boolean);
    if (parts.length < 2) return false;

    const cnMultiSuffixes = ['com.cn', 'net.cn', 'org.cn', 'gov.cn', 'edu.cn'];
    const lastTwo = parts.slice(-2).join('.');
    let sld = parts.length >= 2 ? parts[parts.length - 2] : '';
    if (cnMultiSuffixes.includes(lastTwo) && parts.length >= 3) {
      sld = parts[parts.length - 3];
    }

    return sld === domain;
  } catch (e) {
    return false;
  }
};

// xinxinhw
export const IS_YS_DOMAIN = (() => {
  return isDomainLaunch(YUNSHANG_DOMAIN);
})();

// shefynmis
export const IS_VN_DOMAIN = (() => {
  return isDomainLaunch(VN_DOMAIN);
})();

export const PAY_LOGO_MAP = {
  default: {
    header: require('@/assets/imgs/pay/header_logo.png'),
    footer: require('@/assets/imgs/pay/footer_logo.png')
  },
  ys: {
    header: require('@/assets/imgs/ys/pay/header_logo.png'),
    footer: require('@/assets/imgs/ys/pay/footer_logo.png')
  },
  vn: {
    header: '', // 越南留空
    footer: require('@/assets/imgs/vn/pay/footer_logo.png')
  }
};

export const getPayLogoConfig = () => {
  if (IS_VN_DOMAIN) {
    return PAY_LOGO_MAP.vn;
  }

  if (IS_YS_DOMAIN) {
    return PAY_LOGO_MAP.ys;
  }

  return PAY_LOGO_MAP.default;
};

export const PAGE_META_CONFIG_MAP = {
  vn: {
    title: 'Kỳ Tích Trở Lại',
    description:
      'Kỳ Tích Trở Lại - Nạp Thẻ Chính Thức, Nhận Ưu Đãi Độc Quyền Trang nạp thẻ chính thức của Kỳ Tích Trở Lại, hỗ trợ nạp game nhanh chóng, an toàn và tiện lợi.',
    favicon: require('@/assets/imgs/vn/favicon_logo.png')
  },
  ysEn: {
    title: 'Azure Tale-Official Top-Up Center',
    description:
      'Welcome to the [Azure Tale] Official Top-Up Center. Enjoy a secure, fast, and reliable payment experience directly from the developer.',
    favicon: require('@/assets/imgs/ys/favicon.ico')
  },
  ysEu: {
    title: 'Land of Arielia-Official Top-Up Center',
    description:
      'Welcome to the [Azure Tale] Official Top-Up Center. Enjoy a secure, fast, and reliable payment experience directly from the developer.',
    favicon: require('@/assets/imgs/ys/favicon.ico')
  }
};

export const resolvePageMetaConfig = area => {
  if (IS_VN_DOMAIN) {
    return PAGE_META_CONFIG_MAP.vn;
  }

  if (IS_YS_DOMAIN) {
    return area === 'eu' ? PAGE_META_CONFIG_MAP.ysEu : PAGE_META_CONFIG_MAP.ysEn;
  }

  return null;
};
